import { useSelector } from 'react-redux'

import { QuickLinks } from './components/QuickLinks/QuickLinks'
import { RequestTable } from './components/RequestTable/RequestTable'
import { TrialEndedGracePeriodModal } from './components/TrialEndedGracePeriodModal/TrialEndedGracePeriodModal'
import { YourTrialEndsCallout } from './components/YourTrialEndsCallout/YourTrialEndsCallout'

import styles from './HomePage.module.scss'

import { selectDaysLeft, selectHasActiveEnterpriseSubscription, selectName } from '@/store/features/user/userSlice'
import { extractFirstName } from '@/utils'

export default function HomePage() {
  const name = useSelector(selectName)
  const firstName = extractFirstName(name)
  const title = name ? `Welcome, ${firstName}` : 'Welcome'
  const hasActiveEnterpriseSubscription = useSelector(selectHasActiveEnterpriseSubscription)

  // When a team is in the trialing state, they can either:
  // - Have no stripe subscription (meaning the user is on an in house trial and has not interacted with stripe yet)
  // - Have a stripe subscription in the trialing state but this means a card has been added so we no longer need to show this
  const showYourTrialEndsCallout = !hasActiveEnterpriseSubscription
  const daysLeft = useSelector(selectDaysLeft)

  // Intentional two-tier nudge for admins in grace: modal is the one-shot overlay (dim backdrop hides the callout while open), callout is the persistent reminder after dismissal — don't add mutual exclusion or the reminder is lost on subsequent visits.
  return (
    <div className={styles.homeRoot}>
      <h6>{title}</h6>
      {showYourTrialEndsCallout && <YourTrialEndsCallout daysLeft={daysLeft} />}
      <RequestTable />
      <QuickLinks />
      <TrialEndedGracePeriodModal />
    </div>
  )
}
